import {defineMessages} from "react-intl";

const messages = defineMessages({
  editMe: {
    description: "Edit this description",
    defaultMessage: "Edit me!",
    id: "ElectrodeElectrifyReactComponent19.samsclub.editMe"
  }
});

module.exports = messages;



// WEBPACK FOOTER //
// ./src/lang/tenants/samsclub/default-messages.js